module.exports = __webpack_public_path__ + "static/img/university-harvard.83a05b10.png";